import { render, staticRenderFns } from "./dataread.vue?vue&type=template&id=0667ae71"
import script from "./dataread.vue?vue&type=script&lang=js"
export * from "./dataread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports